import { render, staticRenderFns } from "./commsComponent.vue?vue&type=template&id=21e0e332"
import script from "./commsComponent.vue?vue&type=script&lang=js"
export * from "./commsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports